import SettingService from "../../../shared/services/SettingService";
import { db } from "../../../shared/plugins/firebase-app";

const settingService = new SettingService(db);
export default settingService;
